<script>
import con from '@services/connection'
import Title from '@components/section-title'
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'
import SimuladorComparativo from '@views/simulador-comparativo'
import Vue from 'vue'

export default {
  components: { Title, SimuladorComparativo },
  data() {
    return {
      busModal: new Vue(),
      loading: false,
      cliente: null,
      hash_simulacao: null,
    }
  },
  created() {
    GlobalBus.$on(MODAL.MODAL_SIMULATOR_COMPARE, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.MODAL_SIMULATOR_COMPARE, this.open)
  },
  methods: {
    open(cliente, body) {
      this.cliente = cliente
      this.hash_simulacao = body.hash_simulacao
      this.busModal.$emit('dialog', true)

      this.$nextTick(() => {
        GlobalBus.$emit('changeClient')
      })
    },
    save() {
      if (this.loading) {
        return
      }
      this.loading = true

      // requisition

      this.busModal.$emit('dialog', false)
      this.loading = false
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" max-width="1200">
    <Title
      title="Comparativo de simulação"
      :subtitle="cliente ? cliente.name : ''"
    />
    <SimuladorComparativo
      :cliente-modal="cliente"
      :hash-simulacao-modal="hash_simulacao"
    />

    <template v-slot:actions="{ close }">
      <v-spacer />

      <v-spacer />
    </template>
  </BaseModal>
</template>


